import { loadStripe } from '@stripe/stripe-js';

export const getStripeInstance = async () => {
  // todo: turn to a singleton
  const stripeInstance = await loadStripe(process.env.STRIPE_PUBLIC_KEY);

  return stripeInstance;
};
